import { GET_ACTIVE_WALLET_PLAN_REQUEST, GET_ACTIVE_WALLET_PLAN_SUCCESS, GET_ACTIVE_WALLET_PLAN_FAILURE, GET_ACTIVE_WALLET_PLAN_RESET, } from "../../actions";
const initialState = {
    ActivePlanData: null,
    loading: false,
    error: null,
};
const getActiveWalletPlanReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ACTIVE_WALLET_PLAN_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, ActivePlanData: action.payload });
        case GET_ACTIVE_WALLET_PLAN_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, ActivePlanData: null, error: null });
        case GET_ACTIVE_WALLET_PLAN_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload, ActivePlanData: null });
        case GET_ACTIVE_WALLET_PLAN_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, ActivePlanData: null, error: null });
        default:
            return state;
    }
};
export default getActiveWalletPlanReducer;
